import { enumify } from '../lib/typeInference.js';
import { PaymentProvider } from './payment.types.js';

export const primaryPlatforms = ['UNKNOWN', 'IOS', 'ANDROID', 'WEB'] as const;
export type PrimaryPlatform = (typeof primaryPlatforms)[number];
export const PrimaryPlatformEnum = enumify(primaryPlatforms);

export function isPrimaryPlatform(obj: unknown): obj is PrimaryPlatform {
    return primaryPlatforms.includes(obj as any);
}

export const roleTypes = ['USER', 'ADMIN', 'GUEST'] as const;
export type RoleType = (typeof roleTypes)[number];
export const RoleTypeEnum = enumify(roleTypes);

export type PaymentServiceIds = { [key in PaymentProvider]?: string };

export interface IAddress {
    name?: string;
    address: {
        line1: string;
        line2?: string;
        city: string;
        region: string;
        postalCode: string;
        country: string;
    };
    coordinates: [number, number];
    note?: string;
}
export interface IUser<IDTYPE> {
    _id: IDTYPE;
    tenantId: IDTYPE;
    state: 'ACTIVE' | 'PENDING';
    primaryPlatform: PrimaryPlatform;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    // deprecate
    // subscribed: boolean;
    birthdate?: Date | null; // FIXME some records have this set as null
    gender?: 'MALE' | 'FEMALE';
    roles: RoleType[];
    demo?: boolean;
    // deprecate
    // points: number;
    tier?: string;
    balance?: number;
    defaultTip?: {
        scheme: 'ABSOLUTE' | 'PERCENTAGE';
        amount: number;
    };
    hasPaymentCard: boolean;
    hasProfilePhoto: boolean;
    isRegisteredForPushNotifications: boolean;
    hasAgreedToReceiveMarketing: boolean;
    hasAgreedToShareData: boolean;
    favouriteLocations?: string[];
    favouriteProducts?: any[];
    // FIXME type this properly
    card?: any;
    contacts?: any;
    extended?: any;
    // deprecate
    // reviewCandidate: string;
    deleted?: boolean;
    resetUniqueDeviceVerification?: boolean;
    uniqueDeviceIdAndroid?: string;
    created: Date;
    updatedAt: Date;
    loyaltyProvider?: string;
    // Ids of user as stored on POS, POS loyalty, and Payment Service platforms
    externalPosId?: string;
    externalLoyaltyId?: string;
    externalPaymentServiceIds?: PaymentServiceIds;
    phoneNumberLastUsedToOrder?: string;
    addresses?: IAddress[];
    lastUsedAddress?: string;
    externalLoyaltyMemberNumber?: string;
}
